export const column: { id: number; label: string }[] = [
  {
    id: 0,
    label: "ID",
  },
  {
    id: 11,
    label: "дата регистрации",
  },
  {
    id: 1,
    label: "имя",
  },
  {
    id: 2,
    label: "телефон",
  },
  {
    id: 3,
    label: "всего поездок",
  },
  {
    id: 4,
    label: "СБ",
  },
];
